let opener;
function formatPolicyLinks() {
  const canonical = document.querySelector('link[rel="canonical"]')?.href || window.location.href;
  const hosts = new Set([window.location.hostname, new URL(canonical).hostname, window.Shopify?.shop].filter(Boolean).map((host) => host.replace(/^www\./, "")));
  document.querySelectorAll(".shopify-policy__body a[href]").forEach((link) => {
    const url = new URL(link.href, window.location.href);
    if (!["http:", "https:"].includes(url.protocol)) return;
    if (hosts.has(url.hostname.replace(/^www\./, ""))) {
      link.removeAttribute("target");
      return;
    }
    link.target = "_blank";
    const rel = new Set(link.rel.split(/\s+/).filter(Boolean));
    rel.add("noopener");
    rel.add("noreferrer");
    link.rel = [...rel].join(" ");
    const description = new Set((link.getAttribute("aria-describedby") || "").split(/\s+/).filter(Boolean));
    description.add("sp-external-link-note");
    link.setAttribute("aria-describedby", [...description].join(" "));
  });
}

function enableMenus() {
  if (typeof HTMLDialogElement === "undefined") return;
  document.querySelectorAll("[data-sp-menu-toggle]").forEach((button) => {
    const dialog = document.getElementById(button.getAttribute("aria-controls"));
    if (typeof dialog?.showModal === "function") button.hidden = false;
  });
}

document.addEventListener("click", (event) => {
  if (!(event.target instanceof Element)) return;
  const toggle = event.target.closest("[data-sp-menu-toggle]");
  if (toggle) {
    const dialog = document.getElementById(toggle.getAttribute("aria-controls"));
    if (typeof dialog?.showModal !== "function") return;
    opener = toggle;
    toggle.setAttribute("aria-expanded", "true");
    dialog.showModal();
    return;
  }

  const dialog = event.target.closest(".sp-site-menu");
  if (!dialog) return;
  if (event.target.closest("[data-sp-menu-close], a[href]")) {
    dialog.close();
    return;
  }
  if (event.target === dialog) {
    const bounds = dialog.getBoundingClientRect();
    if (
      event.clientX < bounds.left ||
      event.clientX > bounds.right ||
      event.clientY < bounds.top ||
      event.clientY > bounds.bottom
    ) dialog.close();
  }
});

document.addEventListener("close", (event) => {
  if (!event.target.matches?.(".sp-site-menu")) return;
  opener?.setAttribute("aria-expanded", "false");
  if (opener?.isConnected) opener.focus({ preventScroll: true });
  opener = undefined;
}, true);

document.addEventListener("shopify:section:load", enableMenus);
enableMenus();
formatPolicyLinks();
